import { useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { ArrowLeft } from "lucide-react";

const QuienesSomos = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <main className="min-h-screen bg-slate-50 px-4 py-24">
        <section className="mx-auto max-w-4xl">
          <button
            type="button"
            onClick={() => navigate("/")}
            className="mb-6 inline-flex items-center gap-2 text-sm font-bold text-slate-600 transition hover:text-[#0056D2]"
          >
            <ArrowLeft className="h-4 w-4" />
            Volver al inicio
          </button>

          <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm sm:p-10">
            <p className="text-xs font-black uppercase tracking-wide text-[#F97316]">
              Lo que nos mueve
            </p>
            <h1 className="mt-3 max-w-3xl text-3xl font-black leading-tight text-slate-950 sm:text-4xl">
              Espacios comerciales inteligentes para negocios que quieren crecer
            </h1>
            <p className="mt-4 max-w-3xl text-base leading-7 text-slate-600">
              Nos mueve ayudar a que más ideas y negocios crezcan en México,
              ofreciéndoles propiedades comerciales mejor presentadas, impulsadas
              por IA, con información y datos que les ayuden a elegir la mejor
              ubicación.
            </p>
            <p className="mt-4 max-w-3xl text-base leading-7 text-slate-600">
              No se trata solo de publicar locales, bodegas o terrenos. Se trata
              de conectar espacios con potencial y negocios listos para crecer.
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default QuienesSomos;
